import { useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import { SaveEmailForNewsletter } from "../../../../services";
import { PDLButton, PDLTypography } from "../../dna";

import { ApiError } from "../../../../models";
import "./index.scss";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    setSuccessMessage(null);
    setErrorMessage(null);

    if (!email) {
      setErrorMessage("Informe um e-mail válido.");
      return;
    }

    try {
      setIsLoading(true);

      await SaveEmailForNewsletter({ email: email.trim() });

      setSuccessMessage("E-mail salvo, entraremos em contato!");
      setEmail("");
    } catch (error) {
      const errorMsg =
        (error as ApiError)?.response?.data?.message ||
        "Não foi possível cadastrar seu e-mail. Tente novamente.";

      setErrorMessage(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="d-none d-md-flex align-items-start">
        <Col className="ps-0">
          <Form.Control
            type="email"
            placeholder="Insira seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />

          <div className="feedback-message-container">
            {successMessage && (
              <PDLTypography size="xs" variant="success">
                {successMessage}
              </PDLTypography>
            )}

            {errorMessage && (
              <PDLTypography size="xs" variant="danger">
                {errorMessage}
              </PDLTypography>
            )}
          </div>
        </Col>

        <Col className="pe-0 col-sm-auto">
          <PDLButton type="submit" variant="primary" disabled={isLoading}>
            {isLoading ? "Enviando..." : "Cadastre-se na Newsletter"}
          </PDLButton>
        </Col>
      </Row>

      <div className="d-md-none">
        <Row className="mb-2">
          <Col xs={12} className="px-0">
            <Form.Control
              type="email"
              placeholder="Insira seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
          </Col>
        </Row>

        {(successMessage || errorMessage) && (
          <Row className="mb-2">
            <Col xs={12} className="px-0">
              {successMessage && (
                <PDLTypography size="xs" variant="success">
                  {successMessage}
                </PDLTypography>
              )}

              {errorMessage && (
                <PDLTypography size="xs" variant="danger">
                  {errorMessage}
                </PDLTypography>
              )}
            </Col>
          </Row>
        )}

        <Row>
          <Col xs={12} className="px-0">
            <PDLButton
              type="submit"
              variant="primary"
              className="w-100"
              disabled={isLoading}
            >
              {isLoading ? "Enviando..." : "Cadastre-se na Newsletter"}
            </PDLButton>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default NewsletterForm;
